/**
 * FAQ form
 * Javascript functionality for a pop up form.
 * @version 3.0.0
 * @exports FaqFormPopUp
 */
export default class FaqFormPopUp {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		this.body = document.getElementsByTagName('BODY')[0];

		// FAQ form elements
		this.faqBtn = document.getElementById('faq-button');
		this.faqFormClose = document.getElementById('faq-close');

		this.faqForm = document.getElementById('faq-form');
		this.faqPageCover = document.getElementById('faq-page-cover');

		this._initFaqBox();
	}

	/**
	 * Opens the faq box.
	 * @public
	 */
	openPane(pane, button) {
		pane.style.display = 'block';

		if (pane.getAttribute('id') === 'faq-form') {
			setTimeout(() => {
				this.body.classList.add('faq-open');
				this.body.classList.add('faq-is-visible');
			}, 50);
		}

		setTimeout(() => {
			pane.setAttribute('aria-hidden', false);
			button.setAttribute('aria-expanded', true);
			this.focusTrap = this.trapFocus(pane);
			this.focusableElements = this.toggleFocusableElements(pane);
		}, 50);
	}

	/**
	 * Closes the menu.
	 * @public
	 */
	closePane(pane, button) {
		if (pane.getAttribute('id') === 'faq-form') {
			this.body.classList.remove('faq-open');
			setTimeout(() => {
				this.body.classList.remove('faq-is-visible');
			}, 100);
		}

		pane.setAttribute('aria-hidden', true);
		button.setAttribute('aria-expanded', false);
		setTimeout(() => {
			pane.style.display = 'none';
			this.focusableElements.release();
			this.focusableElements = null;
		}, 50);
	}
	/**
	 * Function that initiate the side menu on desktop.
	 * @private
	 */
	_initFaqBox() {
		if (this.faqBtn) {
			this.faqBtn.addEventListener('click', e => {
				e.preventDefault();

				this.openPane(this.faqForm, this.faqBtn);
			});
		}

		if (this.faqFormClose) {
			this.faqFormClose.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.faqForm, this.faqBtn);
			});
		}

		if (this.faqPageCover) {
			this.faqPageCover.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.faqForm, this.faqBtn);
			});
		}
	}
	/**
	 * Trap focus
	 * @param {Object} focusNode - The page main menu as a DOM node.
	 * @public
	 */
	trapFocus(focusNode) {
		let nodes = document.querySelectorAll(
				'a, button, input, select, textarea, svg, area, details, summary, iframe, object, embed, [tabindex], [contenteditable]'
			),
			newNodes = [],
			menuButtonNode = document.querySelector('#menu-button');
		nodes.forEach(node => {
			if (!focusNode.contains(node) && node.getAttribute('tabindex') !== '-1') {
				if (node !== menuButtonNode) {
					newNodes.push(node);
				}
			}
		});
		newNodes.forEach(node => {
			node.setAttribute('tabindex', '-1');
		});
		return {
			release: function() {
				newNodes.forEach(node => {
					node.removeAttribute('tabindex');
				});
			},
		};
	}

	toggleFocusableElements(container) {
		const elements = container.querySelectorAll(
			'a, button, input, select, textarea, svg, area, details, summary, iframe, object, embed, [tabindex], [contenteditable]'
		);

		elements.forEach(node => {
			node.setAttribute('tabindex', '0');
		});

		return {
			release: function() {
				elements.forEach(node => {
					node.setAttribute('tabindex', '-1');
				});
			},
		};
	}
}
